export default "__VITE_ASSET__31kn5zFW__"